import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';

@Component({
  selector: 'app-truck-registration-summary',
  templateUrl: './truck-registration-summary.component.html',
  styleUrls: ['./truck-registration-summary.component.scss']
})
export class TruckRegistrationSummaryComponent extends AbstractWidgetComponent implements OnInit {

  gatekeeperMandatory: boolean;
  isUsingSmartphone: boolean;
  numberPlate: string;
  driver: string;
  carrier: string;

  constructor(
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.gatekeeperMandatory = this.dashboardContext.getContextValue(TerminalContextConstants.gatekeeperMandatory);
    this.isUsingSmartphone = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
      === TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE;
    this.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
    this.driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
    this.carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
